import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { ReactNode } from 'react'

export const getCollapseIcon = <T extends { isActive?: boolean }>(
    panelProps: T,
): ReactNode => {
    if (panelProps.isActive) {
        return <UpOutlined />
    } else {
        return <DownOutlined />
    }
}
